module.exports = __webpack_public_path__ + "img/icon_周.def28250.svg";